import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, DialogActions } from '@mui/material';

import Modal from 'src/components/common/Modal';

import { styles } from './index.styles';

interface DeleteDownloadsModalProps {
  onClose: () => void;
  onDelete: () => void;
  showModal: boolean;
  isDeleting: boolean;
}

const DeleteDownloadsModal: FC<DeleteDownloadsModalProps> = ({
  showModal,
  onClose,
  onDelete,
  isDeleting,
}) => {
  const { t } = useTranslation(['downloadManager', 'common']);

  return (
    <Modal
      headline={t('downloadManager:DeleteAllData')}
      isOpen={showModal}
      onClose={onClose}
      closeIconHidden={isDeleting}
    >
      <DialogActions>
        <Button
          sx={styles.cancelButton}
          fullWidth
          onClick={onClose}
          disabled={isDeleting}
        >
          {t('common:cancel')}
        </Button>

        <Button fullWidth onClick={onDelete} disabled={isDeleting}>
          {isDeleting ? <CircularProgress size={20} /> : t('common:confirm')}
        </Button>
      </DialogActions>
    </Modal>
  );
};

export default DeleteDownloadsModal;
